/**
 * Роли и права за достъп (Раздел 9 от ТЗ).
 *
 * Матрицата е данни и живее в shared, за да няма две версии на истината —
 * сървърът налага правата, а UI-ят само скрива недостъпното.
 */
export const USER_ROLES = ['ADMIN', 'MONITORING', 'MANAGER'];
export const PERMISSIONS = [
    'recordings:upload',
    /** Списък, резюмета и оценки. */
    'recordings:list',
    /** Пълна транскрипция. */
    'recordings:transcript',
    /** Сваляне на аудиото. */
    'recordings:download',
    'recordings:reprocess',
    'recordings:delete',
    'users:manage',
    'settings:manage',
    'audit:read',
];
const ROLE_PERMISSIONS = {
    ADMIN: new Set(PERMISSIONS),
    MONITORING: new Set([
        'recordings:upload',
        'recordings:list',
        'recordings:transcript',
        'recordings:download',
        'recordings:reprocess',
    ]),
    MANAGER: new Set(['recordings:list']),
};
export function can(role, permission) {
    return ROLE_PERMISSIONS[role].has(permission);
}
export function permissionsOf(role) {
    return [...ROLE_PERMISSIONS[role]];
}
/**
 * Маскиране на телефонния номер за роля Ръководител (Раздел 10).
 * Прилага се в сериализатора на сървъра — немаскираната стойност не стига до браузъра.
 */
export function maskMsisdn(msisdn) {
    if (msisdn.length === 0)
        return '';
    if (msisdn.length <= 6)
        return `${msisdn.slice(0, 3)}***`;
    return `${msisdn.slice(0, 4)}***${msisdn.slice(-3)}`;
}
//# sourceMappingURL=permissions.js.map